// extracted by mini-css-extract-plugin
export default {"mainButton":"styles_mainButton__S9ubh","innerButton":"styles_innerButton__yW5u+","btnGroup":"styles_btnGroup__beCn2"};